import { api } from "../../common/config/api";

export const SUPPORT_URL = {
   getRequests: `${api.withAPI}/v1/support`,
   modifyRequest: `${api.withAPI}/v1/support`
}
